<template>
  <v-container fluid class="pa-0 loginOverlay d-flex flex-column">
    <v-row no-gutters style="flex: 1 1 auto;">
      <v-col v-if="!isPhoneBool" cols="auto" class="d-flex flex-column pa-3"
        style="background-color: #F2F2F2; width: 300px;">

        <v-row no-gutters class="flex-grow-0">
          <v-col cols="auto">
            <v-img src="@/assets/text-loader-animation.svg" width="100" contain>
            </v-img>
            <div v-if="!isPhoneBool" class="useThemeTextColor ml-3" style="font-size: 13px !important;">
              <b> Equipment management made simple.</b>
            </div>
          </v-col>
        </v-row>

        <v-row no-gutters style="flex: 1 1 auto;" align="center">
          <v-list class="py-0" dense style="background-color: transparent;">
            <v-list-item v-for="(portal, index) in portalList" :key="index" link :href="portal.link"
              :disabled="portal.disabled">
              <v-list-item-title :class="portal.active ? 'primary--text' : (portal.disabled ? 'disabled--text' : '')">
                {{ portal.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-row>

        <v-row no-gutters class="flex-grow-0">
          <v-col cols="auto">
            <v-container class="py-2">
              <v-row no-gutters>
                <v-col style="color: #737373;">
                  <small>
                    Patched: {{ buildDate }}
                  </small>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col style="color: #404040;">
                  <small v-if="$store.state.Version">
                    Version {{ $store.state.Version.Version }} Build
                    {{ $store.state.Version.Build }}.{{ $store.state.Version.Revision }}
                  </small>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>

      <v-col :cols="0" class="d-flex flex-column justify-center align-center">
        <v-card flat :width="isPhoneBool ? '90vw' : 380" class="transparent">

          <div class="d-flex justify-center">
            <v-img src="/api2/Report/logo" :max-width="isPhoneBool ? 200 : 280" />
          </div>



          <SendOTPForm v-if="formmode == 'sendOtp'" v-model="email" @cancel="formmode = undefined"
            @next="formmode = 'validateOtp'">
          </SendOTPForm>

          <OTPForm v-else-if="formmode == 'validateOtp' && email" v-model="otp" :email="email"
            @cancel="formmode = undefined" @next="formmode = 'setPassword'">
          </OTPForm>

          <SetPwForm v-else-if="formmode == 'setPassword' && email && otp" v-model="pw" :email="email" :otp="otp"
            @cancel="formmode = undefined" @next="formmode = 'continue'">
          </SetPwForm>

          <ContinueForm v-else-if="formmode == 'continue' && email && pw" :password="pw" :email="email"
            @cancel="formmode = undefined">
          </ContinueForm>

          <LoginForm v-else v-model="email" @recoverpw="formmode = 'sendOtp'">
          </LoginForm>

        </v-card>
      </v-col>
      <!-- 
      <v-col cols="4" class="d-flex flex-column align-center justify-center pa-3">
        <v-img src="@/assets/placeholder.png" width="100%" contain>
        </v-img>
      </v-col>
      -->
    </v-row>

    <v-row no-gutters class="flex-grow-0" style="height: 30px;">
      <PageFooter />
    </v-row>
  </v-container>
</template>


<script>
import http from "@/api/client";
import clientAPI from "@/api/ClientAPIMixin";
import PageFooter from "@/components/Sections/AppSections/PageFooter.vue";
import rules from "@/helpers/Mixins/RuleMixin.js";
import LoginForm from "@/views/login/LoginForm.vue";
import ContinueForm from "./ContinueForm.vue";
import OTPForm from "./OTPForm.vue";
import SendOTPForm from "./SendOTPForm.vue";
import SetPwForm from "./SetPwForm.vue";

export default {
  name: "LoginWrapperView",
  components: {
    LoginForm,
    SendOTPForm,
    OTPForm,
    SetPwForm,
    PageFooter,
    ContinueForm,
  },
  mixins: [rules, clientAPI],

  data() {
    return {
      otp: "",
      pw: "",
      expiery: null,
      loading: false,
      connectionStatuses: {
        backend: "loading",
        db: false,
        erp: true,
      },

      portalList: {
        ServiceProvider: { title: this.$t("servicesystem.loginform.text.sp_portal"), link: window.location.origin + "/ServiceProvider", active: true, disabled: false },
        CustomerPortal: { title: this.$t("servicesystem.loginform.text.customer_portal"), link: window.location.origin + "/customer", active: false, disabled: true },
        //ProductPortal: { title: "Product portal", link: "/product", active: false, disabled: true },
        TechnicianPortal: { title: this.$t("servicesystem.loginform.text.technician_portal"), link: 'https://apps.apple.com/us/app/qwips-technician/id1541338722?app=itunes&ign-mpt=uo%3D4', active: false, disabled: true },
        PartnerPortal: { title: this.$t("servicesystem.loginform.text.partner_portal"), link: window.location.origin + "/partner", active: false, disabled: true },
      },
    };
  },

  mounted() {
    this.getSiteVersionInfo();
    this.getPortals();
  },

  beforeDestroy() {
    this.formmode = undefined;
    this.email = undefined;
  },

  methods: {
    getSiteVersionInfo() {
      this.$store.dispatch("getSiteInfo");
    },

    getPortals() {
      http()
        .get("api2/app/portal")
        .then((response) => {
          console.log('api2/app/portal', response.data)
          this.options = response.data;
          if (this.options.Technician) {
            this.portalList.TechnicianPortal.disabled = false;
          }
          if (this.options.CustomerPortal) {
            this.portalList.CustomerPortal.disabled = false;
          }
          if (this.options.PartnerPortal) {
            this.portalList.PartnerPortal.disabled = false;
          }
        });
    }
  },

  computed: {
    buildDate() {
      if (this.$store.state.Version && this.$store.state.Version.Build) {
        var daysSince1Jan2000 = this.$store.state.Version.Build;
        var firstJan2000 = "2000-01-01T00:00:00";
        var dDay = this.addDates(this.i18nDateFormat, firstJan2000, daysSince1Jan2000);
        return dDay /*+ " " + dTime + ' (CEST)'*/;
      } else {
        return "Unknown";
      }
    },

    formmode: {
      get() {
        return this.$route.query.pwm;
      },
      set(update) {
        //console.log("Setting pwm to", update);
        this.$router.replace({ query: { ...this.$route.query, pwm: update } });
      },
    },

    email: {
      get() {
        return this.$route.query.email;
      },
      set(update) {
        this.$router.replace({ query: { ...this.$route.query, email: update } });
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.loginOverlay {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}

#logoImg {
  max-width: 250px;
  margin-top: 50%;
  animation: slideup 0.6s ease-out 0.8s forwards;
}

@keyframes slideup {
  0% {
    margin-top: 50%;
    max-width: 250px;
  }

  100% {
    margin-top: 0%;
    max-width: 150px;
  }
}
</style>